<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [config]="pageConfig"
  (onAdd)="onCreate('', true)"
  (sortObject)="getSortItems($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (onShowHelpPage)="onShowHelpPage()"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
>
  <!---------------------------------------- Table Content --------------------------------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-text-center !tw-p-4">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- title -->
        <td>
          <td-value copyToClipboard [value]="item?.title"></td-value>
        </td>

        <!-- fileSizePerKilobyte -->
        <td>
          <td-value
            copyToClipboard
            [value]="item?.fileSizePerKilobyte"
          ></td-value>
        </td>

        <!-- organizationName -->
        <td>
          <td-value copyToClipboard [value]="item?.organizationName"></td-value>
        </td>

        <!-- status -->
        <td>
          <span
            [matTooltip]="
              item?.status | enumToText : SocialMediaFileStatusEnumValues
            "
          >
            <i [mediaStatusStyle]="item?.status"></i>
          </span>
        </td>

        <!-- fileTypes -->
        <td>
          <span
            [matTooltip]="
              item?.fileTypes | enumToText : SocialMediaFileTypesEnumValues
            "
          >
            <i [mediaFileTypeStyle]="item?.fileTypes"></i>
          </span>
        </td>

        <!-- created -->
        <td>
          <td-value type="dateTimeWithSpace" [value]="item?.created"></td-value>
        </td>

        <!------------------------------- operations -------------------------------->
        <td class="sticky-td">
          <div app-menu-btn [matMenuTriggerFor]="menu" [isShowDotsMenu]="true"></div>

          <mat-menu #menu="matMenu" xPosition="before">
            <!-- show file -->
            <div app-menu-btn icon="mdi mdi-text-box-multiple-outline mdi-20px" color="indigo" title="common.showFile"
              (click)="onShowFiles(item.id, item?.fileTypes)"></div>
          

            <!-- edit Status button -->
            <div app-menu-btn *ngIf="permissionService.userState()?.organizationId == 1" icon="edit" title="common.editStatus"
              (click)="onEditStatus(item.id, item?.status)"></div>
          

            <!-- delete button -->
            <div app-menu-btn icon="delete" (click)="onDelete(item.id, item?.title)">
            </div>
          
          </mat-menu>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!--------------------------------------- Audit ---------------------------------------->
<ng-container *ngIf="pageConfig?.isVisibleAuditPage">
  <app-audit
    [service]="currentService"
    [methodName]="auditApiMethodName"
    (hidePage)="onHideAuditPage()"
  >
  </app-audit>
</ng-container>
<!--------------------------------------------------------------- help ---------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="pageName"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
